export const FINISH_CURRENT_SCENE_PRELOAD = 'GAME_FINISH_CURRENT_SCENE_PRELOAD'
export const FINISH_NEXT_SCENES_PRELOAD = 'GAME_FINISH_NEXT_SCENES_PRELOAD'
export const PRELOAD_START = 'PRELOAD_START'
export const PRELOAD_PROGRESS = 'PRELOAD_PROGRESS'

export const finishCurrentScenePreload = (sceneId) => {
  return { type: FINISH_CURRENT_SCENE_PRELOAD, data: sceneId }
}
export const finishNextScenesPreload = (sceneId) => {
  return { type: FINISH_NEXT_SCENES_PRELOAD, data: sceneId }
}
export const startPreload = ({ toPreload, isCurrent, sceneId }) => {
  return { type: PRELOAD_START, data: { toPreload, isCurrent, sceneId } }
}
export const notifyProgress = (assetId, url, elem) => {
  return { type: PRELOAD_PROGRESS, data: { assetId, url, elem } }
}
